import ComicCard from '@/components/base/ComicCard';
import { allComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = allComics.filter((c) => c.rating >= 4.7).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">高评分韩漫精选，口碑爆棚的好看韩国漫画</p>
        </div>
        <a
          href="/category/recommend"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {featured.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}